import { Component, Event, EventEmitter, getAssetPath, h, Host, State } from '@stencil/core';

import wcShared from '@web-components/shared';

import { Store } from '../../../../../../utils/Stores/store';

@Component({
  tag: 'chat-message-error-default-component',
  styleUrl: 'chat-message-error-default-module.scss',
  shadow: true,
})
export class ModuleChatMessageErrorDefault {
  @Event() messagesEnded: EventEmitter<number>;
  @Event() sectionChangeEvent: EventEmitter<IWCContextClose[]>;

  @State() countdown = 5;

  private interval;

  componentDidLoad() {
    this.interval = setInterval(() => {
      if (this.countdown === 0) {
        this.goToExit();
      } else {
        this.countdown--;
      }
    }, 1000);
  }

  componentDidUpdate() {
    this.messagesEnded.emit(500);
  }

  private goToExit() {
    this.sectionChangeEvent.emit(['faq_list']);
    clearInterval(this.interval);
    setTimeout(() => {
      document.dispatchEvent(new CustomEvent('reloadApp'));
    });
  }

  private tradUnity() {
    if (this.countdown > 1) {
      return wcShared?.translate('secondes');
    } else {
      return wcShared?.translate('seconde');
    }
  }

  render() {
    return (
      <Host>
        <div class={{ error: true, 'error--full': Store?.get('is_full') }}>
          <img
            src={getAssetPath('./../assets/icons/beep-offline.svg')}
            alt={wcShared?.translate('Erreur')}
          />
          <p>
            {wcShared?.translate(
              'Oups, $name$ semble indisponible, mais pas de panique notre support est la pour vous !',
              {
                name: Store?.get('beepAvatar')?.name,
              },
            )}{' '}
            😎
          </p>
          <div class="error__redirect">
            {wcShared?.translate('Vous allez etre redirige dans $seconds$ $unity$', {
              seconds: this.countdown,
              unity: this.tradUnity(),
            })}
          </div>
          <span
            onClick={() => {
              this.goToExit();
            }}
          >
            {wcShared?.translate('Continuer')}
          </span>
        </div>
      </Host>
    );
  }
}
